import React, {Component} from 'react';
import { SentimentSatisfied, SentimentVerySatisfied } from '@mui/icons-material';
import SentimentVeryDissatisfied from '../../../static/icon/afs/ic_sentiment_dissatisfied_white_48px.svg';
import SentimentDissatisfied from '../../../static/icon/afs/ic_sentiment_semi-dissatisfied_white_48px.svg';
import SentimentVeryDissatisfiedNavy from '../../../static/icon/afs/ic_sentiment_dissatisfied_navy_48px.svg';
import SentimentDissatisfiedNavy from '../../../static/icon/afs/ic_sentiment_semi-dissatisfied_navy_48px.svg';

import SentimentNeutral from '../../../static/icon/afs/ic_sentiment_neutral_white_48px.svg';
import SentimentNeutralNavy from '../../../static/icon/afs/ic_sentiment_neutral_navy_48px.svg';

class CheckBoxItem extends Component {
    constructor(props) {
      super(props);
    }

    setActive(bool) {
        this.props.onItemActive(this.props.data);
    }

    svgIcon = (number) => {
        switch (number) {
            case 0:
                return (<img src={SentimentVeryDissatisfied} width={30} height={30} className='fixImg' />)
            case 1:
                return (<img src={SentimentDissatisfied} width={30} height={30} className='fixImg' />)
            case 2:
                return (<img src={SentimentNeutral} width={30} height={30} className='fixImg' />)
            case 3:
                //return (<img src={SentimentSatisfied} width={30} height={30} className='fixImg' />)
                return <SentimentSatisfied />
            case 4:
                //return (<img src={SentimentVerySatisfied} width={30} height={30} className='fixImg' />)
                return <SentimentVerySatisfied />
        }
        return
    }

    updateSVG = number => {
        if (number === 0 || number === 1 || number === 2) {
          switch (number) {
            case 0:
              return (
                <img
                  src={SentimentVeryDissatisfiedNavy}
                  width={30}
                  height={30}
                  className="fixImg"
                />
              );
            case 1:
              return (
                <img
                  src={SentimentDissatisfiedNavy}
                  width={30}
                  height={30}
                  className="fixImg"
                />
              );
            case 2:
              return (
                <img
                  src={SentimentNeutralNavy}
                  width={30}
                  height={30}
                  className="fixImg"
                />
              );
            default:
            // code block
          }
          return (
            <img
              src={
                number === 0
                  ? SentimentVeryDissatisfiedNavy
                  : SentimentDissatisfiedNavy
              }
              width={30}
              height={30}
              className="fixImg"
            />
          );
        } else {
          return this.svgIcon(number);
        }
      };

    render() {
        let item = this.props.data;
        return (
            <li className='feeling-wrapper'>
                <div className={this.props.active ? 'feeling-wrapper-sub active' : 'feeling-wrapper-sub'} onClick={this.setActive.bind(this)}>
                    {(!this.props.active) ? this.svgIcon(this.props.number) : this.updateSVG(this.props.number)}
                    <input className={this.props.active ? 'custom-feeling-checkbox active' : 'custom-feeling-checkbox'} id={this.props.id} type="checkbox" value={item.text} />
                    <label htmlFor={this.props.id}>{item.text}</label>
                </div>
            </li>
        );
    }
}

export default class CustomCheckBox extends Component {
    constructor (props) {
        super(props)
        this.state = {
            activeItem: null
        };
    }

    componentDidMount = () => {
        
        if(this.props.prepop && this.props.prepop.hasOwnProperty('answers')) {
            
            let questionAnswerId = this.props.prepop.answers[0].id
            let foundItem = this.getFirstQuestion().answerOptions.find(item => {
                return item.id === questionAnswerId
            })    

            
            if(foundItem) {
                this.setState({
                    activeItem: foundItem
                })
            }
            
        }
    }

    onItemActive(item) {
        this.setState({activeItem: item})
        var newData = {
            "questionNumber": this.props.questionNumber,
            "valid": true,
            "id": this.getFirstQuestion().id,
            "answers": [
                {
                    "id": item.id,
                    "text": item.text
                }
            ]
        };
        this.props.manageFormData(newData)
    }

  getFirstQuestion = () => this.props.data.questions[0]

    render() {
        var self = this;
        var output = this.getFirstQuestion().answerOptions.map((x, i) => {
            return (
                <CheckBoxItem key={i} number={i} id={i} data={x} onItemActive={self.onItemActive.bind(self)} active={x === this.state.activeItem} />
            )
        })
    return (
        <div>
            <h3 className='question-title'>{this.getFirstQuestion().text}</h3>
            <div className='custom-checkbox-wrapper'>
                <ul className='feeling-wrapper-parent'>
                    {output}
                </ul>
            </div>
        </div>
    )
  }
}
